export const marginUtil = {
  findMaxTransferOutAmount(accounts: MarginAccount[], currency: string) {
    const account = accounts.find((o) => o.currency === currency);
    return account
      ? {
          maxTransferOutAmountEv: Number(account.maxTransferOutAmountEv),
          maxTransferOutAmount: account.maxTransferOutAmount,
        }
      : {
          maxTransferOutAmountEv: 0,
          maxTransferOutAmount: (0).toFixed(8),
        };
  },
};
